import packageInfo from '../../package.json';
import { EnvironmentLevel } from '../app/core/environment/environment-level';
import { Environment } from './environment.model';
export const environment: Environment = {
  apiUrl: 'https://apimahlzeitdev.amfamily.it/api/v1',
  clientId: 'WebApplication',
  buildVersion: packageInfo.version,
  envLevel: EnvironmentLevel.Development,
  wsUrl: 'wss://apimahlzeitdev.amfamily.it/ws',
};
